import React from "react";
import { BsBriefcaseFill } from "react-icons/bs";
import { FiCalendar, FiExternalLink, FiCheckCircle } from "react-icons/fi";

const Experience = () => {
  const highlights = [
    "Full ownership of 7 commercial WordPress plugins — from concept and architecture through release and long-term maintenance.",
    "End-to-end development across the stack: frontend interfaces, backend logic, REST APIs, and Gutenberg blocks.",
    "Continuous feature enhancement, bug fixing, and version releases driven by user feedback and support requests.",
    "Custom development, plugin customization, and performance optimization for a diverse portfolio of client projects.",
  ];

  const products = [
    {
      name: "Darkify",
      free: "https://wordpress.org/plugins/darkify/",
      pro: "https://darkifywp.com/",
    },
    {
      name: "Eventful",
      free: "https://wordpress.org/plugins/eventful/",
      pro: "https://wpeventful.com/",
    },
    {
      name: "Eventful for Elementor",
      free: "https://wordpress.org/plugins/eventful-for-elementor/",
      pro: "https://themeatelier.net/downloads/eventful-for-elementor/",
    },
    {
      name: "Domain For Sale",
      free: "https://wordpress.org/plugins/domain-for-sale/",
      pro: "https://wpdomainforsale.com/",
    },
    {
      name: "Greet Bubble",
      free: "https://wordpress.org/plugins/greet-bubble/",
      pro: "https://themeatelier.net/downloads/greet-bubble/",
    },
    {
      name: "Chat Help",
      free: "https://wordpress.org/plugins/chat-help/",
      pro: "https://wpchathelp.com/",
    },
    {
      name: "Better Chat Support",
      free: "https://wordpress.org/plugins/better-chat-support/",
      pro: "https://themeatelier.net/downloads/better-chat-support-for-messenger/",
    },
  ];

  const technologies = [
    "WordPress",
    "React",
    "Next.js",
    "Express",
    "Mongoose",
    "Strapi",
    "Firebase",
  ];

  return (
    // <!-- ========== Experience section start ========== -->
    <div className="section-padding experience" id="experience">
      <div className="container">
        <div className="row">
          <div
            className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="section-title-center text-center">
              <span>Experience</span>
              <h2 className="display-6">Working Experience</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div
            className="col-lg-10 col-xl-9"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="experience__card">
              <span className="experience__card-icon">
                <BsBriefcaseFill />
              </span>
              <div className="experience__card-body">
                <div className="experience__header">
                  <div className="experience__heading">
                    <h3 className="experience__role">
                      Full Stack Web Developer
                    </h3>
                    <h4 className="experience__company">
                      <a
                        href="https://themeatelier.net"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Fixolab
                        <FiExternalLink />
                      </a>
                    </h4>
                  </div>
                  <span className="experience__date">
                    <FiCalendar />
                    Aug 2022 &ndash; Present
                  </span>
                </div>

                <div className="experience__line"></div>

                <p>
                  I lead the end-to-end development of commercial WordPress
                  products and deliver tailored solutions for a global client
                  base. Since August 2022, I have owned multiple plugins from
                  concept to release &mdash; pairing clean, scalable architecture
                  with a strong focus on usability and performance.
                </p>

                <ul className="experience__highlights">
                  {highlights.map((item) => (
                    <li key={item}>
                      <FiCheckCircle />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                <div className="experience__products">
                  <h5 className="experience__products-title">
                    Plugins I own &amp; maintain
                  </h5>
                  <div className="experience__products-list">
                    {products.map((product) => (
                      <div
                        key={product.name}
                        className="experience__product-item"
                      >
                        <span className="experience__product-name">
                          {product.name}
                        </span>
                        <span className="experience__product-links">
                          <a
                            href={product.free}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Free
                          </a>
                          <a
                            href={product.pro}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="is-pro"
                          >
                            Pro
                          </a>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                <p>
                  Beyond product development, I contribute to a wide range of
                  client projects at Fixolab &mdash; handling custom development,
                  plugin customization, feature implementation, performance
                  optimization, and ongoing support for diverse WordPress-based
                  solutions.
                </p>

                <div className="experience__tech">
                  <h5 className="experience__tech-title">Tech I work with</h5>
                  <div className="experience__tech-list">
                    {technologies.map((tech) => (
                      <span key={tech} className="experience__tech-item">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <!-- ========== Experience section end ========== -->
  );
};

export default Experience;
